'use client';

import { Suspense } from 'react';
import JourneyCheckoutContent from './JourneyCheckoutContent';

export default function JourneyCheckoutPage() {
  return (
    <Suspense fallback={
      <div className="min-h-screen bg-[var(--background)] flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-[var(--primary)] border-t-transparent rounded-full animate-spin" />
      </div>
    }>
      <JourneyCheckoutContent />
    </Suspense>
  );
}
